<!--<mat-form-field class="address-input" style="width: 30%; " *ngIf="mobileQuery.matches ? false : true">
  <mat-icon matPrefix (click)="clearSearch()" style="color: #959595;" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="search">
    {{search ? 'search' : 'cancel'}}
  </mat-icon>
  <input  type="text" placeholder="{{'Address' | localize}}" aria-label="Text" matInput (click)="inputClicked()"
         [matAutocomplete]="auto">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">-->
<!--<mat-option *ngFor="let filteredAddress of filteredOptions | async" [value]="filteredAddress" style="height: unset;white-space: normal;font-size: smaller;">
  {{filteredAddress[0]}}
</mat-option>-->
<!--</mat-autocomplete>
</mat-form-field>-->

<div class="search-bar">
  <mat-icon matPrefix (click)="clearSearch()" style="color: #959595;" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="search">
    {{search ? 'search' : 'cancel'}}
  </mat-icon>
  <!--<input  type="text" placeholder="Adres Ara" />-->
  <input type="text" placeholder="{{'Address' | localize}}" aria-label="Text" matInput (click)="inputClicked()" [formControl]="searchAddressControl"
  [matAutocomplete]="auto"
  autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    <mat-option *ngFor="let filteredAddress of filteredOptions | async" [value]="filteredAddress" style="height: unset;white-space: normal;font-size: smaller;">
      {{filteredAddress[0]}}
    </mat-option>
  </mat-autocomplete>
  <!-- <span class="shortcut">CTRL+K</span> -->
</div>
